export const QUALITY_EVIDENCE_MAGIC = new Uint8Array([0x56, 0x4c, 0x51, 0x31]);
export const QUALITY_EVIDENCE_MAX_MANIFEST_BYTES = 64 * 1024;
